module.exports = __webpack_public_path__ + "@/assets/img/001-boy.45d15c02.svg";